<template>
  <auth-layout class="not-found-page">
    <div class="centered" style="color: #3c6837">
      <h1>
        <em class="not-found-icon nc-icon nc-puzzle-10"></em>
        {{ $t('vie.Pag.Das.Gen.attention') }}
      </h1>
      <hr style="width: 95%" />
      <p>{{ $t('vie.Pag.Das.Gen.noPermissions') }}</p>
      <p class="text-center text-muted">
        {{ $t('vie.Pag.Das.Gen.boostYourOrganization') }}<br />
        <a href="https://smartcultivo.com/contacto/" target="_blank">{{
          $t('vie.Pag.Das.Gen.contactUs')
        }}</a>
      </p>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from 'src/views/Layouts/AuthLayout.vue';

export default {
  components: {
    AuthLayout,
  },
};
</script>
<style lang="scss">
.not-found-page {
  .full-page > .content,
  .centered {
    min-height: calc(100vh - 160px);
  }
  .not-found-icon {
    margin-right: 10px;
  }
  .centered {
    h1,
    i {
      font-size: 50px;
    }
    p {
      font-size: 20px;
    }
    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #4c4a4a;
  }
}
</style>
